/* global SideDrawer */

/* 10/24 a11y: remember the last control the shopper pressed, so the drawer can hand focus back to it on close. */
function grFocusable(el) {
  return !!(el && el.isConnected && !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[hidden]'));
}
function grRecordTrigger(evt) {
  const t = evt.target && evt.target.closest ? evt.target.closest('button, a[href], [role="button"], input[type="submit"], summary') : null;
  if (t && !t.closest('cart-drawer')) window.__grLastTrigger = t;
}
document.addEventListener('pointerdown', grRecordTrigger, true);
document.addEventListener('click', grRecordTrigger, true);
document.addEventListener('keydown', (evt) => { if (evt.key === 'Enter' || evt.key === ' ') grRecordTrigger(evt); }, true);

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * 10/24 a11y: work out a focusable opener when the caller passed none (or passed an icon inside a link).
   */
  open(opener, elementToFocus, callback) {
    let o = opener && opener.closest ? (opener.closest('a[href], button, input, select, [tabindex]') || opener) : opener;
    if (!o || !o.isConnected || this.contains(o)) {
      const a = document.activeElement;
      o = (a && a !== document.body && !this.contains(a)) ? a : (window.__grLastTrigger || null);
    }
    super.open(o, elementToFocus, callback);
  }

  /**
   * 10/24 a11y: if the opener has gone (closed card, re-rendered button), use the last pressed control instead.
   */
  close(callback) {
    if (!grFocusable(this.opener)) {
      const alt = window.__grLastTrigger;
      this.opener = (grFocusable(alt) && !this.contains(alt)) ? alt : null;
    }
    super.close(callback);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
